const LOAD_DATA_SUB_DISTRICT           = 'LOAD_DATA_SUB_DISTRICT'
const LOAD_DATA_SUB_DISTRICT_SUCCESS   = 'LOAD_DATA_SUB_DISTRICT_SUCCESS'
const LOAD_DATA_SUB_DISTRICT_FAILED    = 'LOAD_DATA_SUB_DISTRICT_FAILED'
const UNMOUNT_DATA_SUB_DISTRICT        = 'UNMOUNT_DATA_SUB_DISTRICT'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const subDistrictReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_SUB_DISTRICT:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_SUB_DISTRICT_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_SUB_DISTRICT_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_SUB_DISTRICT:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default subDistrictReducer;